import { render } from "./CurrentProductInfo.vue?vue&type=template&id=654017cd&scoped=true&ts=true"
import script from "./CurrentProductInfo.vue?vue&type=script&lang=ts"
export * from "./CurrentProductInfo.vue?vue&type=script&lang=ts"

import "./CurrentProductInfo.vue?vue&type=style&index=0&id=654017cd&scoped=true&lang=css"

import exportComponent from "P:\\roboworks\\easyros\\easyros\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-654017cd"]])

export default __exports__